
<script>
// 新闻公告
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    goDetail(item) {
      if (item.sourceUrl) {
        window.open(item.sourceUrl)
        return
      }
      this.$router.push({
        path: '/account/news-detail/' + item.id
      })
    }
  },
};
</script>
<template>
    <div class="news-announcement-container">
      <div class="news-item flex justify-between vertical-center" v-for="item in list" :key="item.id" @click="goDetail(item)">
        <div class="news-item-title overflow-text font-color1">{{ item.title }}</div>
        <div class="news-item-publish-date font-color3">{{ item.publishDate }}</div>
      </div>
    </div>
</template>

<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.news-announcement-container {
  padding: 0 2px;
  .news-item {
    height: 35px;
    gap: 12px;
    .news-item-title { font-size: 14px; }
    .news-item-publish-date { font-size: 12px; }
  }
}
</style>
